import script from "./AdminForm.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminForm.vue?vue&type=script&setup=true&lang=js"

import "./AdminForm.vue?vue&type=style&index=0&id=0b69423e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b69423e"]])

export default __exports__